import React, { useEffect, useState } from "react";
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import { useGlobalContext } from "../../../Contexts/GlobalContext";
import axios from "axios";
import { BASE_URL } from "../../../Utlils";
const endpointData = {
  complete: 10,
  terminate: 20,
  "Quality Terminate": 30,
  "Quota Full": 40,
};
const RedirectsAndKey = ({ user, setUser }) => {
  const { setSnackbar, organization, getOrganization } = useGlobalContext();
  const [inputData, setInputData] = useState("");
  const [showKey, setShowKey] = useState(false);
  const handleEye = () => {
    setShowKey(!showKey);
  };
  function generateRandomString() {
    const length = 30;
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }

    setInputData(result);
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (inputData?.length <= 35) {
        let data = await axios.put(
          `${BASE_URL}/company/${user?.organizationId}`,
          { key: inputData }
        );
        await getOrganization(user?.organizationId);
        setSnackbar({
          open: true,
          msg: "Secret key generated successfully!",
          severity: "success",
        });
        console.log("data.data=>", data.data);
      } else {
        setSnackbar({
          open: true,
          msg: "Key is too long...",
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        msg: "Something went wrong",
        severity: "error",
      });
    }
  };
  useEffect(() => {
    if (Object.keys(organization || {})?.length) {
      setInputData(organization?.key);
    }
  }, [Object.keys(organization || {})?.length]);
  //   console.log("user=>", user);
  //   console.log(inputData?.length);
  return (
    <div className="w-full flex flex-col gap-6 h-full py-5">
      <div className="pb-6 border-b border-gray-200">
        <h1 className="text-[#0226BE] text-[28px] font-[600] mb-2">
          Redirects & Secret Key
        </h1>
        <p className="text-gray-600 text-[14px]">Manage your secret key and redirect endpoints</p>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <form
          onSubmit={handleSubmit}
          className="flex w-full items-end gap-4"
        >
          <div className="flex flex-col gap-2 flex-1">
            <label className="text-[#1a1a1a] text-[14px] font-[500]">
              {organization?.key ? "Your Secret Key" : "Generate Secret Key"}
            </label>
            <div className="flex items-center relative">
              <input
                type={showKey ? "text" : "password"}
                placeholder="Enter secret key"
                disabled={organization?.key || user?.role !== "admin"}
                value={inputData}
                onChange={(e) => {
                  const newValue = e.target.value;
                  if (/^[A-Za-z0-9]{0,35}$/.test(newValue)) {
                    setInputData(newValue);
                  }
                }}
                name="secretKey"
                required
                className="border border-gray-300 h-[48px] text-[#1a1a1a] pl-4 pr-12 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 hover:border-gray-400 placeholder:text-gray-400 disabled:bg-gray-50 disabled:cursor-not-allowed w-full"
              />
              <button
                type="button"
                className="absolute right-3 p-1.5 hover:bg-gray-100 rounded cursor-pointer transition-colors"
                onClick={handleEye}
              >
                {showKey ? (
                  <BsFillEyeFill size={18} className="text-gray-600" />
                ) : (
                  <BsFillEyeSlashFill size={18} className="text-gray-600" />
                )}
              </button>
            </div>
          </div>
          {!organization?.key && (
            <>
              <button
                type="button"
                disabled={user?.role !== "admin"}
                onClick={generateRandomString}
                className="border-2 border-[#0226BE] text-[#0226BE] text-[14px] font-[500] py-2.5 px-5 rounded-md hover:bg-blue-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Auto Generate
              </button>
              <button
                type="submit"
                disabled={user?.role !== "admin"}
                className="bg-[#0226BE] text-white text-[14px] font-[500] py-2.5 px-5 rounded-md hover:bg-[#021ea8] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Save
              </button>
            </>
          )}
        </form>
        {organization?.key && (
          <p className="text-[14px] text-gray-600 mt-4">
            To edit your secret key, please{" "}
            <a
              href="mailto:diysupport@miratsinsights.com"
              className="text-[#0226BE] font-[500] hover:underline"
            >
              contact support team
            </a>
          </p>
        )}
      </div>

      {organization?.key && (
        <div className="space-y-4">
          <h1 className="text-[#1a1a1a] text-[18px] font-[600]">
            Redirect Endpoints
          </h1>
          <div className="border border-gray-200 rounded-lg overflow-hidden bg-white">
            <div className="w-full overflow-x-auto containerScroll">
              <table className="whitespace-nowrap text-left w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                      Type
                    </th>
                    <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                      Endpoint
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Object?.keys(endpointData)?.map((d, i) => (
                    <tr key={i} className="border-b border-gray-100 transition-all hover:bg-blue-50">
                      <td className="px-4 py-4 capitalize text-[#1a1a1a] font-[500] text-[14px]">
                        {d}
                      </td>
                      <td className="px-4 py-4 text-gray-600 font-[400] text-[13px] font-mono">
                        {window.location.origin}
                        /21df0c3543ff3bd23cecdaf921ff4a704a113d06dc1ec21045a186ad0f2f9a42?h=
                        {organization?.key}
                        &id=[ref_id]&s={endpointData?.[d]}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RedirectsAndKey;
